import React from 'react';

import t from '../../../labels/labelling-utils';
import { IComponent } from '../../../typings/generic-component';
import { Sport } from '../../../typings/motorsports';
import {
  RACE_STATUS_FIXTURE,
  RACE_STATUS_PLAYED,
  RACE_STATUS_PLAYING,
  RaceSessionStatus,
  RaceSessionType,
  freePractices,
} from '../../../typings/race-session';
import { getSessionLabels } from '../../../utils/motorsports';
import { GPFLAG, placeholdersMap } from '../../../utils/placeholders-motorsports';
import { makeClassNames } from '../../../utils/styles';
import { dateFormat } from '../../../utils/times';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import Label from '../../atoms/label/label';
import Text from '../../atoms/text/text';
import './lgp-header.scss';

export interface ILgpHeader extends IComponent {
  sportTag?: Sport;
  sessionStatus: RaceSessionStatus;
  sessionName: RaceSessionType;
  flagImgUrl: string;
  customGpName: string;
  startDate: string;
  endDate: string;
  isSticky?: boolean;
}

const classNames = () =>
  makeClassNames({
    lgpHeaderContainer: 'lgp-header__container',
    lgpHeaderDates: 'lgp-header__dates',
    lgpHeroTitle: 'lgp-hero__title',
    lgpHeroFlag: 'lgp-hero__flag',
    lgpHeroLabel: 'lgp-hero__label',
    lgpHeroCircuit: 'lgp-hero__circuit',
    lgpHeaderLabelsContainer: 'lgp-header__labels-container',
    lgpHeroPlaceholderImg: 'lgp-hero__placeholder-img',
  });

const LgpHeader = ({
  sportTag,
  sessionStatus,
  sessionName,
  flagImgUrl,
  customGpName,
  startDate,
  endDate,
  isSticky,
}: ILgpHeader) => {
  const cn = classNames();

  const labels = getSessionLabels(sportTag);

  return (
    <div className={cn.lgpHeaderContainer} data-sticky={isSticky}>
      <div className={cn.lgpHeroTitle}>
        <ImgPlaceholder
          placeholder={placeholdersMap[GPFLAG]}
          src={flagImgUrl}
          aria-hidden
          alt=""
          className={cn.lgpHeroFlag}
        />
        <Text fontSize="22" fontWeight="500" color="light">
          {customGpName}
        </Text>
      </div>
      <div className={cn.lgpHeroLabel}>
        {sessionStatus === RACE_STATUS_FIXTURE && (
          <div className={cn.lgpHeaderDates}>
            <Label
              label={`${dateFormat({ date: startDate, format: 'D MMMM' })} - ${dateFormat({
                date: endDate,
                format: 'D MMMM YYYY',
              })}`}
              noRounded
              hasBgAlpha
            />
          </div>
        )}
        {sessionStatus === RACE_STATUS_PLAYING && (
          <div className={cn.lgpHeaderLabelsContainer}>
            <Label isLive isInverted noRounded label={t('lgp.session.live')} />
            {sessionName && (
              <Label
                isWhiteOnRed
                noRounded
                label={`${freePractices.includes(sessionName) ? 'Prove ' : ''}${labels[sessionName]}`}
              />
            )}
          </div>
        )}
        {sessionStatus === RACE_STATUS_PLAYED && (
          <div className={cn.lgpHeaderLabelsContainer}>
            <Label isWhiteOnRed noRounded label={t('lgp.session.end')} />
            {sessionName && (
              <Label
                hasBgAlpha
                noRounded
                label={`${freePractices.includes(sessionName) ? 'Prove ' : ''}${labels[sessionName]}`}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LgpHeader;
